import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { differenceInSeconds, intervalToDuration, secondsToMilliseconds, } from 'date-fns';
import { useCallback, useEffect, useRef, useState } from 'react';
import { Icon } from '../Icon/Icon';
import { Text } from '../Text/Text';
import { FlexContainer } from '../layout/FlexContainer';
// It's less than 1s because setInterval is not precise and we don't want to skip a second
const TICK_INTERVAL_MS = 200;
const getSecondsLeft = (countDownTo) => Math.max(differenceInSeconds(countDownTo, new Date()), 0);
export const CountDown = ({ countDownTo, onFinish }) => {
    const tickInterval = useRef(null);
    const [secondsLeft, setSecondsLeft] = useState(getSecondsLeft(countDownTo));
    const handleTick = useCallback(() => {
        const newSecondsLeft = getSecondsLeft(countDownTo);
        setSecondsLeft(newSecondsLeft);
        if (newSecondsLeft <= 0) {
            onFinish();
            if (tickInterval.current !== null) {
                clearInterval(tickInterval.current);
            }
        }
    }, [onFinish, countDownTo]);
    useEffect(() => {
        tickInterval.current = setInterval(handleTick, TICK_INTERVAL_MS);
        return () => {
            if (tickInterval.current !== null) {
                clearInterval(tickInterval.current);
            }
        };
    }, [handleTick]);
    const duration = intervalToDuration({
        start: 0,
        end: secondsToMilliseconds(secondsLeft),
    });
    const minutes = duration.minutes ?? 0;
    const seconds = duration.seconds ?? 0;
    const formattedSeconds = seconds.toString().padStart(2, '0');
    const text = `${minutes}:${formattedSeconds}`;
    return (_jsxs(FlexContainer, { verticalAlign: 'center', gap: '1/4', children: [_jsx(Icon, { name: 'OutlineTimer', size: 'small' }), _jsx(Text, { variant: 'caption', children: text })] }));
};
